import { useState } from "react";
import { COMPANY_CONTACT } from "../../constants/data";

export default function FloatingWhatsApp({
  phoneNumber = COMPANY_CONTACT.whatsappNumber,
  message = COMPANY_CONTACT.whatsappMessage,
  label = "¿Necesitas ayuda? Escríbenos"
}) {
  const [isHovered, setIsHovered] = useState(false);

  // Sanitizar el número (dejar solo dígitos)
  const cleanPhone = phoneNumber.replace(/\D/g, "");
  const encodedMsg = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${cleanPhone}?text=${encodedMsg}`;

  return (
    <div
      className="floating-whatsapp"
      style={{
        position: "fixed",
        bottom: "28px",
        right: "28px",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      }}
    >
      {/* Tooltip / Badge emergente */}
      <div
        style={{
          background: "rgba(10, 24, 15, 0.92)",
          color: "#ffffff",
          padding: "8px 14px",
          borderRadius: "12px",
          fontSize: "13px",
          fontWeight: 600,
          border: "1px solid rgba(37, 211, 102, 0.35)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.45)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          pointerEvents: "none",
          transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
          opacity: isHovered ? 1 : 0.9,
          transform: isHovered ? "translateX(0) scale(1)" : "translateX(4px) scale(0.98)",
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {/* Indicador en línea (Punto verde titilante) */}
        <span
          style={{
            position: "relative",
            display: "inline-flex",
            width: "8px",
            height: "8px",
          }}
        >
          <span
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              background: "#25D366",
              opacity: 0.75,
              animation: "ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite",
            }}
          />
          <span
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              background: "#25D366",
            }}
          />
        </span>
        <span>{label}</span>
      </div>

      {/* Botón flotante de WhatsApp */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          position: "relative",
          width: "58px",
          height: "58px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
          color: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: isHovered
            ? "0 12px 30px rgba(37, 211, 102, 0.55), 0 0 20px rgba(37, 211, 102, 0.4)"
            : "0 8px 24px rgba(37, 211, 102, 0.4)",
          transform: isHovered ? "scale(1.1) translateY(-2px)" : "scale(1) translateY(0)",
          transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
          textDecoration: "none",
          cursor: "pointer",
        }}
      >
        {/* Icono oficial SVG de WhatsApp */}
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.472 14.382C17.182 14.237 15.765 13.539 15.501 13.443C15.237 13.346 15.044 13.298 14.851 13.588C14.658 13.878 14.102 14.531 13.933 14.724C13.764 14.918 13.595 14.942 13.305 14.797C13.015 14.652 12.081 14.346 10.974 13.359C10.112 12.591 9.531 11.642 9.362 11.352C9.193 11.062 9.344 10.905 9.49 10.761C9.62 10.632 9.779 10.423 9.924 10.254C10.069 10.085 10.117 9.964 10.214 9.771C10.311 9.578 10.262 9.409 10.19 9.264C10.117 9.119 9.538 7.693 9.296 7.114C9.061 6.549 8.822 6.626 8.644 6.617L8.089 6.608C7.896 6.608 7.582 6.68 7.316 6.97C7.051 7.26 6.299 7.96 6.299 9.387C6.299 10.814 7.34 12.191 7.485 12.384C7.63 12.577 9.533 15.522 12.454 16.784C13.149 17.084 13.693 17.264 14.116 17.399C14.814 17.621 15.45 17.589 15.952 17.514C16.512 17.43 17.677 16.809 17.918 16.132C18.16 15.456 18.16 14.876 18.088 14.755C18.015 14.634 17.762 14.527 17.472 14.382Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C6.477 2 2 6.477 2 12C2 13.819 2.487 15.524 3.336 16.994L2.083 21.571L6.797 20.337C8.212 21.393 9.99 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM4.015 12C4.015 7.59 7.59 4.015 12 4.015C16.41 4.015 19.985 7.59 19.985 12C19.985 16.41 16.41 19.985 12 19.985C10.158 19.985 8.472 19.36 7.126 18.311L6.81 18.066L4.764 18.601L5.309 16.608L5.04 16.279C4.386 15.021 4.015 13.567 4.015 12Z"
            fill="white"
          />
        </svg>
      </a>

      {/* Estilos para animación de pulso y responsive */}
      <style>{`
        @keyframes ping {
          75%, 100% {
            transform: scale(2);
            opacity: 0;
          }
        }
        @media (max-width: 640px) {
          .floating-whatsapp {
            right: 16px !important;
            bottom: calc(16px + env(safe-area-inset-bottom, 0px)) !important;
          }
          .floating-whatsapp > div:first-child {
            display: none !important;
          }
          .floating-whatsapp > a {
            width: 52px !important;
            height: 52px !important;
          }
        }
      `}</style>
    </div>
  );
}
